export default __webpack_public_path__ + "static/media/signin.db82261f.png";